import { SITE } from '../data/site'
import './YouTubeEmbed.css'

interface Props {
  videoId?: string
  title: string
}

/** Inline player only — no duplicate “open YouTube” button (video is already on-page). */
export function YouTubeEmbed({ videoId, title }: Props) {
  const id = videoId?.trim()
  if (!id) {
    return (
      <div className="yt-fallback">
        <p>இந்தப் பக்கத்திற்கான வீடியோ விரைவில் இணைக்கப்படும்.</p>
        <a className="btn btn--gold" href={SITE.youtubeUrl} target="_blank" rel="noopener noreferrer">
          YouTube சேனலைப் பாருங்கள்
        </a>
      </div>
    )
  }

  return (
    <div className="yt-embed">
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${id}?rel=0`}
        title={title}
        loading="lazy"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  )
}
